module.exports = __webpack_public_path__ + "static/media/warrior.365ab565.jpg";